"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.VRCAvatarMeasurementType = void 0;
var VRCAvatarMeasurementType;
(function (VRCAvatarMeasurementType) {
    VRCAvatarMeasurementType[VRCAvatarMeasurementType["UNKNOWN"] = 0] = "UNKNOWN";
    VRCAvatarMeasurementType[VRCAvatarMeasurementType["HEIGHT"] = 1] = "HEIGHT";
    VRCAvatarMeasurementType[VRCAvatarMeasurementType["ARM_SPAN"] = 2] = "ARM_SPAN";
})(VRCAvatarMeasurementType = exports.VRCAvatarMeasurementType || (exports.VRCAvatarMeasurementType = {}));
